import { IPass } from './payease.types';

export const cx = (...classes: Array<string | false | null | undefined>): string => classes.filter(Boolean).join(' ');

export const formatPrice = (value: number): string => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);

export const passHasOptions = (pass: IPass): boolean => pass.options.length > 1;

export const passFromPrice = (pass: IPass): number => (pass.options.length ? Math.min(...pass.options.map((option) => option.price)) : 0);

export const roundToCents = (value: number): number => Math.round(value * 100) / 100;

const QUICK_CASH_DENOMINATIONS = [5, 10, 20, 100];

export const quickCashAmounts = (amountDue: number): number[] => {
  const amounts = [amountDue, ...QUICK_CASH_DENOMINATIONS.map((denomination) => Math.ceil(amountDue / denomination) * denomination)];
  return amounts.filter((amount, index) => amount > 0 && amounts.indexOf(amount) === index);
};
